<template>
  <div>
    <section>
      <div class="card card-custom">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <h3 class="mb-3 title-custom standar-plus">Cotización</h3>
            <h5 class="mb-3 title-custom responsive-plus">Cotización</h5>
            <h5 style="color: red">#Cotizacion: {{ idCotizacion }}</h5>
          </div>
          <h5 class="standar-plus">{{ payload.versionText }}</h5>
          <h5 style="font-size: 10px !important" class="responsive-plus">
            {{ payload.versionText }}
          </h5>
          <hr />
          <div class="row">
            <div class="col-md-4 text-center responsive-plus">
              <div class="row">
                <h2
                  class="fw-bold font-title"
                  style="color: #757575 !important"
                >
                  Paquete {{ paquete }}
                </h2>
                <h2 class="font-title" style="color: #29abe2 !important">
                  PRIMA NETA: ${{ formatMoney(total) }}MXN
                </h2>
              </div>
            </div>
            <div class="col-md-8">
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(cob, ind) in coberturasSeleccionadas(0)"
                      :key="ind"
                    >
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td v-html="getLabelSuma(cob)"></td>
                      <td
                        v-html="
                          cob.checkDeducibles === 0
                            ? ''
                            : `<span class='fw-bold'>${cob.checkDeducibles}%</span>`
                        "
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-4 text-center standar-plus-block">
              <div class="row">
                <div
                  class="fw-bold col-md-12 font-title"
                  style="color: #757575 !important"
                >
                  Paquete {{ paquete }}
                  <br>
                  <span style="color: #29abe2 !important">
                  PRIMA NETA: ${{ formatMoney(total) }}MXN
                </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="coberturasSeleccionadas(1).length > 0">
            <div class="col-md-8">
              <h4 class="fw-bold">Protección extra</h4>
              <div class="table-responsive">
                <table class="table table-sm">
                  <tbody>
                    <tr
                      v-for="(cob, ind) in coberturasSeleccionadas(1)"
                      :key="ind"
                    >
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td v-html="getLabelSuma(cob)"></td>
                      <td
                        v-html="
                          cob.checkDeducibles === 0
                            ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp'
                            : `<span class='fw-bold'>${cob.checkDeducibles}%</span>`
                        "
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-4 mt-3 text-center">
              <h2
                class="font-title"
                style="color: #29abe2 !important"
                v-if="totalextra !== 0"
              >
                PRIMA NETA ${{ formatMoney(totalextra) }}MXN
              </h2>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12 d-flex justify-content-between standar-plus">
              <h2
                class="title-custom font-title"
                style="font-size: 20px !important"
              >
                Este importe incluye IVA y derechos de póliza
              </h2>
              <h2
                class="title-custom font-title"
                style="font-size: 20px !important"
              >
                TOTAL: ${{ formatMoney(primas[0].PRIMATOTAL) }}MXN
              </h2>
            </div>
            <div class="row d-flex justify-content-center responsive-plus">
              <div class="col-md-12 text-center">
                <h2 class="title-custom" style="font-size: 20px !important">
                  TOTAL: ${{ formatMoney(primas[0].PRIMATOTAL) }}MXN
                </h2>
              </div>
              <div class="col-md-12 text-center">
                <p
                  class="title-custom font-title"
                  style="font-size: 12px !important"
                >
                  Este importe incluye IVA y derechos de póliza
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div class="row d-flex justify-content-end">
            <h3 class="mb-4 title-custom">Formas de Pago</h3>
            <CardRadioPago
              class="wizard__card__selection standar-plus col-md-2"
              v-for="(prima, i) in primas"
              :key="i"
              :price="`$${formatMoney(prima.PRIMATOTAL)}`"
              :pricesub="`${formatMoney(prima.RECIBO1)}`"
              :subsecuente="`${formatMoney(prima.RECIBOSUB)}`"
              :title="prima.DESCRIPCION"
              :model="prima.MODEL"
              :changePlan="changePackage"
              :index="i"
            />
            <CardRadioPago
              class="wizard__card__selection responsive-plus col-md-12"
              v-for="(prima, i) in primas"
              :key="i"
              :price="`$${formatMoney(prima.PRIMATOTAL)}`"
              :pricesub="`${formatMoney(prima.RECIBO1)}`"
              :subsecuente="`${formatMoney(prima.RECIBOSUB)}`"
              :title="prima.DESCRIPCION"
              :model="prima.MODEL"
              :changePlan="changePackage"
              :index="i"
              style="width: calc(100%) !important"
            />
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <a id="downloadPdf" download="download.pdf" style="display: none" />
            <!-- <div class="col-md-2">
              <button
                class="btn btn-link font-label mr-2"
                @click="guardarCotizacion('print')"
              >
                <i class="fas fa-print"></i> Imprimir
              </button>
              <button
                class="btn btn-link font-label mr-2"
                @click="guardarCotizacion('descargar')"
              >
                <i class="fas fa-file-pdf"></i> Descargar
              </button>
              
              <button
                class="btn btn-link font-label"
                @click="guardarCotizacion('save')"
              >
                <i class="far fa-bookmark"></i> Guardar cotización
              </button>
            </div> -->
            <div class="col-md-12 text-center responsive-plus">
              <button
                class="btn btn-link btn-rounded w-100"
                @click="guardarCotizacion('email')"
              >
                <i class="fas fa-envelope mr-2"></i> Enviar
              </button>
            </div>
            <div class="col-md-12 d-flex justify-content-end standar-plus">
              <button
                class="btn btn-link btn-rounded mr-2"
                @click="guardarCotizacion('email')"
              >
                <i class="fas fa-envelope"></i> Enviar
              </button>
              <button
                class="btn btn-link btn-rounded mr-2"
                @click="handleNavigation(2)"
              >
                Regresar
              </button>
              <button
                class="btn btn-link btn-rounded mr-2"
                @click="guardarCotizacion('ver')"
              >
                Ver cotización
              </button>
              <button
                class="btn btn-primary btn-rounded"
                @click="handleNavigation(4)"
              >
                Enviar condiciones
              </button>
            </div>
            <div class="col-md-12 responsive-plus">
              <button
                class="btn btn-link btn-rounded w-100 mt-3"
                @click="handleNavigation(2)"
              >
                Regresar
              </button>
            </div>
            <div class="col-md-12 responsive-plus">
              <button
                class="btn btn-link btn-rounded w-100 mt-3"
                @click="guardarCotizacion('ver')"
              >
                Ver cotización
              </button>
            </div>
            <div class="col-md-12 responsive-plus">
              <button
                class="btn btn-primary btn-rounded w-100 mt-3"
                @click="handleNavigation(4)"
              >
                Enviar condiciones
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
.bg-group {
  background-color: #7a818f !important;
  border-bottom-color: #7a818f !important;
}
.font-title {
  font-size: 15px !important;
}
.btn-link {
  border-color: #003b71 !important;
}
@media (max-width: 767px) {
  .responsive-plus {
    display: flex !important;
  }

  .standar-plus {
    display: none !important;
  }

  .standar-plus-block {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .responsive-plus {
    display: none !important;
  }

  .standar-plus {
    display: flex !important;
  }

  .standar-plus-block {
    display: block !important;
  }
}
</style>

<script>
import { format, date } from "../../../../assets/helpers";
import CardRadioPago from "./../../tools/CardRadioPago.vue";
export default {
  components: {
    CardRadioPago,
  },
  props: {
    payload: Object,
    basicas: Array,
    total: Number,
    totalextra: Number,
    idCotizacion: String,
    primas: Array,
    planSelectedPrimas: Number,
    paquete: String,
    tipoPaquete: String,
    showCotizacionExitosa: Boolean,
    verCotizacionModal: Boolean,
    pdfBase: String,
    phoneCondiciones: String,
    marca: String,
    modelo: String,
  },
  data() {
    return {
      descuentos: [],
      uniquePayment: false,
      planSelected: this.planSelectedPrimas,
    };
  },
  methods: {
    async handleNavigation(to) {
      if (to == 2) {
        const shouldGoBack = await this.$swal({
          title: "¿Desea modificar los datos?",
          text: "",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Regresar",
          denyButtonText: "Permanecer aquí",
        });

        if (!shouldGoBack.isConfirmed) {
          return;
        }
        return this.$emit("onChangeStep", to);
      } else {
        this.guardarCondiciones();
      }
    },
    handleSendCotizacion(type) {
      this.$emit("onSendCotizacion", type);
    },
    handleFloatingButton() {
      const floatingButton = document.querySelector(".floating-button");
      const isActive = floatingButton.classList.contains(
        "floating-button--active"
      );

      if (isActive) {
        floatingButton.classList.remove("floating-button--active");
      } else {
        floatingButton.classList.add("floating-button--active");
      }
    },
    handlePaymentMethod(e) {
      const tr = e.target.parentElement.parentElement;
      const isOneActive = tr.parentElement.querySelector(".bg-success");

      if (isOneActive) {
        isOneActive.classList.remove("bg-success");
      }
      tr.classList.add("bg-success");

      this.$emit("update:planSelectedPrimas", this.planSelected);
    },
    numberFormat(amount) {
      return format.money(amount);
    },
    formatMoney(amount) {
      if (isNaN(amount)) {
        return amount;
      }
      return format.money(amount, false);
    },
    handlePayment() {
      const { vig_fin, vig_ini } = this.payload;
      const totalDays = Math.round(date.resta(vig_ini, vig_fin));

      if (totalDays <= 180) {
        this.uniquePayment = true;
      }
    },
    async getDescuentos() {
      const { version, sexo, fecha_nac, km } = this.payload;
      const payload = {
        metodo: "GET_DESCUENTOS_CA",
        data: {
          Genero: sexo,
          Edad: date.getAge(format.date(fecha_nac, "aaaa/mm/dd")),
          ClaveVehiculo: version,
          Kilometraje: km ? +km.replaceAll(",", "") : 0,
        },
      };

      if (!version || !sexo || !fecha_nac) {
        return;
      }

      const res = await this.$store.dispatch("metodoPost", payload);

      if (res) {
        const descuentos = this.$store.getters.getRespuestaREST.map(
          (descuento) => {
            if (descuento) {
              if (descuento.Incremento > 0) {
                descuento.porcentajes = [];
                let porcentaje = descuento.ValorInicio;

                while (porcentaje <= descuento.ValorFin) {
                  descuento.porcentajes.push(porcentaje);
                  porcentaje = porcentaje + descuento.Incremento;
                }
              }

              const replaced = descuento.Descripcion.includes("DESCUENTO")
                ? descuento.Descripcion.split("DESCUENTO ")[1]
                : descuento.Descripcion;

              descuento["Descripcion"] = replaced.toLowerCase();

              return descuento;
            }
          }
        );
        this.descuentos = descuentos.filter((descuento) => descuento);
      }
    },
    async calculaPrimas() {
      const { tipoVigencia, vig_fin, vig_ini } = this.payload;

      const existsRcUsa = this.basicas.findIndex(
        (bas) => bas.NOMENCLATURA === "RCU" && bas.check
      );

      const config = {
        metodo: "GET_CALCULO_PRIMAS_CA",
        data: {
          SumaPrimas: this.total + this.totalextra,
          TipoVigencia: tipoVigencia,
          VigenciaInicio: format.date(vig_ini, "dd/mm/aaaa"),
          VigenciaFin: format.date(vig_fin, "dd/mm/aaaa"),
          CobRcUsa: existsRcUsa !== -1 ? 1 : 0,
          Tipo: "C" // Para endosos es tipo E
        },
      };
      await this.$store.dispatch("metodoPost", config);

      let primasTemp = this.$store.getters.getRespuestaREST;
      primasTemp.map(
        (prima, index) => (prima.MODEL = this.planSelectedPrimas === index)
      );
      this.$emit("update:primas", primasTemp);
    },
    async descargarPDF(idCotizacion, from, type) {
      if (this.planSelectedPrimas === -1) {
        return;
      }

      const payload = {
        metodo: "OBTIENEPDFDOCS",
        data: {
          POLIZA: "",
          ENDOSO: "",
          COTIZACION: idCotizacion,
          RECIBO: "",
          TIPOCOTIZADOR: 2,
          TIPODOCUMENTO: type,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;

        switch (from) {
          case "descargar":
            const tagDownload = document.getElementById("downloadPdf");
            tagDownload.href = `data:application/pdf;base64,${response.data}`;
            tagDownload.download = `${idCotizacion}.pdf`;
            tagDownload.click();
            break;
          case "print":
            let pdfWindow = window.open("");
            pdfWindow.document.write(
              "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                encodeURI(response.data) +
                "'></iframe>"
            );
            break;
          case "ver":
            this.$emit("update:pdfBase", response.data);
            this.$emit("update:verCotizacionModal", true);
            break;
          default:
            break;
        }
      }
    },
    async guardarCotizacion(from) {
      if (this.planSelectedPrimas === -1) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Es necesario seleccionar una forma de pago",
        });
        return;
      }

      const {
        km,
        modelo,
        marca,
        version,
        vig_fin,
        vig_ini,
        universe,
        universe2,
        email,
        cp,
        fecha_nac,
        fullname,
        apaterno,
        amaterno,
        sexo,
        phone,
        fecha_factura,
        agente,
        monto_factura,
      } = this.payload;

      const payload = {
        metodo: "GUARDARCOTIZACION",
        data: {
          AGENTE: agente,
          CLIENTE: {
            CORREO: email,
            CP: cp,
            FECHANACIMIENTO: this.formatDateBirthday(new Date(fecha_nac), 1),
            IDCLIENTE: this.idCliente,
            NOMBRE: `${fullname} | ${apaterno} | ${amaterno}`,
            SEXO: sexo,
            TELEFONO: phone,
          },
          COTIZACION: this.idCotizacion,
          ENTIDAD: universe || universe2,
          FECHAALTA: this.formatDateBirthday(new Date(), 0),
          FECHAINSPECION: "",
          FP: this.primas[this.planSelectedPrimas].CLAVEPAGO,
          GASTOS: this.primas[this.planSelectedPrimas].GASTOSEXPEDICION,
          INCISOS: [
            {
              CLAVE: version,
              COBERTURAS: this.getCoberturas(),
              CONDUCTOR: this.conductorHabitual,
              CONTROLVEHICULAR: this.numeroControlVehicular,
              KILOMETRAJE: km ? +km.replaceAll(",", "") : 0,
              MODELO: modelo,
              MOTOR: this.numeroMotor,
              PLACAS: "",
              SAVEHICULO: monto_factura ? +monto_factura.replaceAll(",", "") : 0,
              SERIE: this.numeroSerie,
              TIPOCARGA: "",
              TIPOPAQUETE: +this.tipoPaquete,
              VALORNUEVO: this.getValorNuevo(),
              FECHAFACTURA: fecha_factura
                ? this.formatDateBirthday(new Date(fecha_factura), 1)
                : "",
            },
          ],
          IVA: this.primas[this.planSelectedPrimas].IVA,
          MONEDA: 0,
          POLIZA: "",
          PRIMANETA: this.primas[this.planSelectedPrimas].PRIMANETA,
          RECARGOS: this.primas[this.planSelectedPrimas].RECARGO,
          SUBTOTAL: this.primas[this.planSelectedPrimas].SUBTOTAL,
          SUMAASEGURADA: this.sumasCoberturas(),
          TOTAL: this.primas[this.planSelectedPrimas].PRIMATOTAL,
          USUARIO: localStorage.getItem("userId"),
          VIGENCIAFIN: this.formatDateBirthday(new Date(vig_fin), 0),
          VIGENCIAINI: this.formatDateBirthday(new Date(vig_ini), 0),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.$emit("update:idCotizacion", response.COTIZACION);
        this.$emit("update:modelo", modelo);
        this.$emit("update:marca", marca);

        switch (from) {
          case "descargar":
            this.descargarPDF(response.COTIZACION, from, 12);
            break;
          case "print":
            this.descargarPDF(response.COTIZACION, from, 12);
            break;
          case "email":
            this.handleSendCotizacion("email");
            break;
          case "save":
            this.$emit("update:showCotizacionExitosa", true);
            this.$emit("update:idCotizacion", response.COTIZACION);
            break;
          case "ver":
            this.descargarPDF(response.COTIZACION, "ver", 12);
          default:
            break;
        }
      }
    },
    async guardarCotizacionEmail() {
      const {
        km,
        modelo,
        marca,
        version,
        vig_fin,
        vig_ini,
        universe,
        universe2,
        email,
        cp,
        fecha_nac,
        fullname,
        apaterno,
        amaterno,
        sexo,
        phone,
        fecha_factura,
        agente,
        monto_factura,
      } = this.payload;

      const payload = {
        metodo: "GUARDARCOTIZACION",
        data: {
          AGENTE: agente,
          CLIENTE: {
            CORREO: email,
            CP: cp,
            FECHANACIMIENTO: this.formatDateBirthday(new Date(fecha_nac), 1),
            IDCLIENTE: this.idCliente,
            NOMBRE: `${fullname} | ${apaterno} | ${amaterno}`,
            SEXO: sexo,
            TELEFONO: phone,
          },
          COTIZACION: this.idCotizacion,
          ENTIDAD: universe || universe2,
          FECHAALTA: this.formatDateBirthday(new Date(), 0),
          FECHAINSPECION: "",
          FP: this.primas[this.planSelectedPrimas].CLAVEPAGO,
          GASTOS: this.primas[this.planSelectedPrimas].GASTOSEXPEDICION,
          INCISOS: [
            {
              CLAVE: version,
              COBERTURAS: this.getCoberturas(),
              CONDUCTOR: this.conductorHabitual,
              CONTROLVEHICULAR: this.numeroControlVehicular,
              KILOMETRAJE: km ? +km.replaceAll(",", "") : 0,
              MODELO: modelo,
              MOTOR: this.numeroMotor,
              PLACAS: "",
              SAVEHICULO: monto_factura ? +monto_factura.replaceAll(",", "") : 0,
              SERIE: this.numeroSerie,
              TIPOCARGA: "",
              TIPOPAQUETE: +this.tipoPaquete,
              VALORNUEVO: this.getValorNuevo(),
              FECHAFACTURA: fecha_factura
                ? this.formatDateBirthday(new Date(fecha_factura), 1)
                : "",
            },
          ],
          IVA: this.primas[this.planSelectedPrimas].IVA,
          MONEDA: 0,
          POLIZA: "",
          PRIMANETA: this.primas[this.planSelectedPrimas].PRIMANETA,
          RECARGOS: this.primas[this.planSelectedPrimas].RECARGO,
          SUBTOTAL: this.primas[this.planSelectedPrimas].SUBTOTAL,
          SUMAASEGURADA: this.sumasCoberturas(),
          TOTAL: this.primas[this.planSelectedPrimas].PRIMATOTAL,
          USUARIO: localStorage.getItem("userId"),
          VIGENCIAFIN: this.formatDateBirthday(new Date(vig_fin), 0),
          VIGENCIAINI: this.formatDateBirthday(new Date(vig_ini), 0),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        console.log(response);
        this.$emit("update:idCotizacion", response.COTIZACION);
        this.$emit("update:modelo", modelo);
        this.$emit("update:marca", marca);
      }
    },

    async guardarCondiciones(telefono) {
      if (this.planSelectedPrimas === -1) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Es necesario seleccionar una forma de pago",
        });
        return;
      }

      const {
        km,
        modelo,
        marca,
        version,
        vig_fin,
        vig_ini,
        universe,
        universe2,
        email,
        cp,
        fecha_nac,
        fullname,
        apaterno,
        amaterno,
        sexo,
        phone,
        fecha_factura,
        agente,
        monto_factura,
      } = this.payload;

      const payload = {
        metodo: "GUARDARCONDICIONES",
        data: {
          AGENTE: agente,
          CLIENTE: {
            CORREO: email,
            CP: cp,
            FECHANACIMIENTO: this.formatDateBirthday(new Date(fecha_nac), 1),
            IDCLIENTE: this.idCliente,
            NOMBRE: `${fullname} | ${apaterno} | ${amaterno}`,
            SEXO: sexo,
            TELEFONO: telefono == undefined ? phone : telefono,
          },
          COTIZACION: this.idCotizacion,
          ENTIDAD: universe || universe2,
          FECHAALTA: this.formatDateBirthday(new Date(), 0),
          FECHAINSPECION: "",
          FP: this.primas[this.planSelectedPrimas].CLAVEPAGO,
          GASTOS: this.primas[this.planSelectedPrimas].GASTOSEXPEDICION,
          INCISOS: [
            {
              CLAVE: version,
              COBERTURAS: this.getCoberturas(),
              CONDUCTOR: this.conductorHabitual,
              CONTROLVEHICULAR: this.numeroControlVehicular,
              KILOMETRAJE: km ? +km.replaceAll(",", "") : 0,
              MODELO: modelo,
              MOTOR: this.numeroMotor,
              PLACAS: "",
              SAVEHICULO: monto_factura ? +monto_factura.replaceAll(",", "") : 0,
              SERIE: this.numeroSerie,
              TIPOCARGA: "",
              TIPOPAQUETE: +this.tipoPaquete,
              VALORNUEVO: this.getValorNuevo(),
              FECHAFACTURA: fecha_factura
                ? this.formatDateBirthday(new Date(fecha_factura), 1)
                : "",
            },
          ],
          IVA: this.primas[this.planSelectedPrimas].IVA,
          MONEDA: 0,
          POLIZA: "",
          PRIMANETA: this.primas[this.planSelectedPrimas].PRIMANETA,
          RECARGOS: this.primas[this.planSelectedPrimas].RECARGO,
          SUBTOTAL: this.primas[this.planSelectedPrimas].SUBTOTAL,
          SUMAASEGURADA: this.sumasCoberturas(),
          TOTAL: this.primas[this.planSelectedPrimas].PRIMATOTAL,
          USUARIO: localStorage.getItem("userId"),
          VIGENCIAFIN: this.formatDateBirthday(new Date(vig_fin), 0),
          VIGENCIAINI: this.formatDateBirthday(new Date(vig_ini), 0),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.$emit("update:idCotizacion", response.COTIZACION);
        this.$emit("update:modelo", modelo);
        this.$emit("update:marca", marca);

        this.$emit("update:phoneCondiciones", telefono == undefined ? phone : this.payload.phone);
        document.getElementById("sendCondicionesModal").click();
      }
    },
    async enviarCondiciones(cotizacion) {
      const { phone, modelo, marca } = this.payload;

      const payload = {
        metodo: "ENVIOCONDICIONESGENERALES",
        data: {
          renovacion: "0",
          cotizacion: cotizacion,
          cotizador: "2",
          telefono: phone,
          vehiculo: `${marca}-${modelo}`,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        console.log(response);
      }
    },
    getValorNuevo() {
      const { monto_factura } = this.payload;
      const valorFactura = monto_factura
        ? +monto_factura.replaceAll(",", "")
        : 0;

      const cobsCheck = this.basicas.filter((cob) => cob.check);

      const searchValorFactura = cobsCheck.find(
        (cob) =>
          cob.SUMAS.find(
            (sum) =>
              sum.VALOR === cob.checkSumas &&
              sum.DESCRIPCION === "VALOR FACTURA"
          ) !== undefined
      );
      const searchValorConvenido = cobsCheck.find(
        (cob) =>
          cob.SUMAS.find(
            (sum) =>
              sum.VALOR === cob.checkSumas &&
              sum.DESCRIPCION === "VALOR CONVENIDO"
          ) !== undefined
      );
      const searchValorComercial = cobsCheck.find(
        (cob) =>
          cob.SUMAS.find(
            (sum) =>
              sum.VALOR === cob.checkSumas &&
              sum.DESCRIPCION === "VALOR COMERCIAL"
          ) !== undefined
      );

      if (searchValorFactura !== undefined) {
        return valorFactura;
      } else if (searchValorConvenido !== undefined) {
        const value = searchValorConvenido.SUMAS.find(
          (sum) => sum.VALOR === searchValorConvenido.checkSumas
        );
        return value.VALOR;
      } else if (searchValorComercial !== undefined) {
        return 0;
      } else {
        return valorFactura;
      }
    },
    formatDateBirthday(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join("/");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    sumasCoberturas() {
      let total = 0;
      this.basicas.map(
        (cob) => (total = cob.check ? total + cob.checkSumas : total + 0)
      );
      return total;
    },
    getCoberturas() {
      const cobsTemp = [];

      this.basicas.map((cob) => {
        if (cob.check) {
          cobsTemp.push({
            CLAVECOBERTURA: cob.NOMENCLATURA,
            DEDUCIBLE: cob.checkDeducibles,
            PRIMACOBERTURA: cob.valor,
            SUBRAMO: "",
            SUMAASEGURADA: cob.checkSumas,
          });
        }
      });

      return cobsTemp;
    },
    coberturasSeleccionadas(type) {
      return this.basicas.filter((bas) => bas.check && bas.OPCIONAL === type);
    },
    getLabelSuma(cob) {
      const suma = cob.SUMAS.find((sum) => sum.VALOR === cob.checkSumas);

      if (suma === undefined) {
        return `${this.verifyTypeSumaAsegurada(cob.SUMAS[0].DESCRIPCION)}`;
      }

      return suma.DESCRIPCION === "AMPARADA"
        ? `<span class="fw-bold">AMPARADA</span>`
        : `${this.verifyTypeSumaAsegurada(suma.DESCRIPCION)}`;
    },
    verifyTypeSumaAsegurada(label) {
      if (
        label !== "VALOR COMERCIAL" &&
        label !== "VALOR FACTURA" &&
        label !== "VALOR CONVENIDO"
      ) {
        return `<span class="fw-bold">$${this.formatMoney(+label)} MXN</span>`;
      } else {
        return `<span class="fw-bold">${label}</span>`;
      }
    },
    changePackage(index) {
      let primasTemp = [...this.primas];

      primasTemp.map((prima, ind) => (prima.MODEL = ind === index));

      this.$emit("update:planSelectedPrimas", index);
      this.$emit("update:primas", primasTemp);
    },
  },
  async mounted() {
    this.$emit("onMounted", "cotizacion");
    this.handlePayment();
    Promise.all([this.calculaPrimas(), this.getDescuentos()]);
  },
};
</script>